module.exports = __webpack_public_path__ + "img/failed.4720f71e.svg";